require('js/webpack-config');
require('es6-promise').polyfill();
require('js/sw-polyfill');

/**
 * When you update a module without updating shapeways.js,
 * this variable can force a manual tag bump.
 * @type {String}
 */
window.FML = '06-29-2017';

var _ = require('underscore');
var $ = require('js/sw-jquery/sw-jquery');
var SW = require('js/lib/sw');
var actions = require('js/lib/actions');
var printJS = require('print-js-updated');
var bindActionCreators = require('js/lib/actions/utils/bindActionCreators');
window.sw = window.SW = SW; // hackish aliases until consolidation
window.printJS = printJS;

// Legacy $.swJquery
$(function () {
  require('js/lib/legacy/jquery-sw-portal');
});

// JQuery Plugins
require('./sw-jquery/plugins/easing')($);
require('./sw-jquery/plugins/slideshow-jquery')($);
require('./sw-jquery/plugins/sw-ajax')($);
require('./sw-jquery/plugins/sw-data-attr')($);
require('./sw-jquery/plugins/sw-data-params')($);
require('./sw-jquery/plugins/sw-hide-show')($);
require('./sw-jquery/plugins/sw-is-in-block-view')($);
require('./sw-jquery/plugins/sw-find-with-self')($);
require('./sw-jquery/plugins/sw-form-values')($);
require('./sw-jquery/plugins/sw-pattern')($);
require('./sw-jquery/plugins/sw-slider')($);
require('./sw-jquery/plugins/sw-sticky-header')($);
require('./sw-jquery/plugins/sw-swiper')($);
require('./sw-jquery/plugins/sw-truncate')($);
require('./sw-jquery/plugins/sw-viewport')($);
require('./sw-jquery/plugins/sw-val')($);
require('./sw-jquery/plugins/sw-caret-router')($);
require('./sw-jquery/plugins/sw-spinner-overlay')($);
require('./sw-jquery/plugins/sw-outer-html')($);
require('./sw-jquery/plugins/sw-val-to-attr')($);

// vendor plugins
require('./sw-jquery/vendor/html.sortable.src')($);
require('./sw-jquery/vendor/jquery.tag-editor')($);
require('./sw-jquery/vendor/jquery.minimalect')($);
require('./sw-jquery/vendor/jquery.selectric')($);
require('./sw-jquery/vendor/jquery.noty.packaged')($);
require('./sw-jquery/vendor/jquery.sticky')($);

// Noty layouts
require('js/sw-jquery/noty-layouts/sw-dialog')($);
require('js/sw-jquery/noty-layouts/sw-center-full')($);
require('js/sw-jquery/noty-layouts/sw-center-content')($);
require('js/sw-jquery/noty-layouts/sw-bottom-right-content')($);
require('js/sw-jquery/noty-layouts/sw-bottom-full')($);

// URL behaviors
require('./lib/location/product-handlers');

// -- Other window message listener --
// This catches ready messages from other windows w/ otherWindowEventBus
// it needs to listen ASAP which is why it lives here
require('./lib/sw-other-window-bus/global-listener');

// Load view builders
//
// Requires some initialization code to activate and must be initialized for all new fragments
// appended to the DOM
//

// Inject SW with boundActionCreators
// This lets you call sw.boundActionCreators.SOME_ACTION_TYPE.someActionCreator(/* args */) rather
// than calling sw.dispatch(actions.SOME_ACTION_TYPE.someActionCreator(/* args */));
SW.actionDispatchers = bindActionCreators(actions, SW.dispatch);

// Vue builders must be run first in order to allow for Vue to create the template from non-modified
// DOM elements. If jQuery events are need inside a Vue, use 'sw-fragment-loaded' on the Vue
// when it is `mounted` and on `updated` and update Vue data using jQuery custom events
require('rrViewComponents/Inshape/TrayCrashRecovery/TrayCrashRecoveryTableComponent/sw-tray-crash-recovery')($('body'));
require('rrViewComponents/Inshape/AccessControl/AccessControlManageUserComponent/sw-user-management-roles')($('body'));
require('rrViewComponents/Inshape/AccessControl/AccessControlManageRolesComponent/sw-access-control-manage-roles')($('body'));
require('rrViewComponents/Inshape/AccessControl/AccessControlManagePermissionsComponent/sw-access-control-manage-permissions')($('body'));
require('rrViewComponents/Inshape/CsPortal/ReactivateCreditCard/reactivate-credit-card')($('body'));
require('rrViewComponents/Inshape/CsPortal/Users/EditUser/edit-user')($('body'));
require('rrViewComponents/Inshape/CsPortal/ContentReview/ContentReviewTable/content-review-table')($('body'));
require('rrViewComponents/Inshape/ManufacturerStatus/UserProductionProcess/user-production-process')($('body'));
require('rrViewComponents//Material/Page/MaterialPageComponent/sw-material-page')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorModelDimensionsComponent/sw-model-material-configurator-model-dimensions')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorMaterialSelectorComponent/sw-model-material-configurator-material-selector')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorColorSelectorComponent/sw-model-material-configurator-color-selector')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorFinishSelectorComponent/sw-model-material-configurator-finish-selector')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorComponent/sw-model-material-configurator')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorAddToCartComponent/sw-model-material-configurator-add-to-cart')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorGrayRenderVizComponent/sw-model-material-configurator-gray-render-viz')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorOptionsHeadingComponent/sw-model-material-configurator-options-heading')($('body'));
require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialConfiguratorModelUpdaterComponent/sw-model-material-configurator-model-updater')($('body'));
import modelFixApp from 'rrViewComponents/Model/Fix/ModelFixAppComponent/model-fix-app-autoloader';
modelFixApp($('body'));
import carousel from 'rrViewComponents/ScheduledContent/ScheduledContentCarasoulComponent/sw-carousel';
carousel($('body'));
import modelTools from 'rrViewComponents/Model/Tools/ModelToolsComponent/sw-model-tools.js';
modelTools($('body'));

import modelRename from 'rrViewComponents/Model/Rename/ModelRenameComponent/sw-model-rename.js';

import newMaterialApp from 'rrViewComponents/Inshape/Admin/Materials/AddMaterial/AddMaterialAppComponent/new-material-app-autoloader';
newMaterialApp($('body'));
SW.on('sw-fragment-loaded', function($el) {

  // Noty should always run first to avoid double-binding races with fragment-loaded
  //
  // Note: this requires us to suppress fragment-loaded on sw.notifications (which is non-default behavior)
  // Note 2: this also limits our ability to add flash messages to our flash messages
  require('./sw-jquery/view-builders/sw-noty')($el);

  // Once we are free from backbone, we will not need to have this in the sw-fragment-loaded handler
  // !!DO NOT ADD VUE HERE UNLESS IT NEEDS TO WORK WITH BACKBONE OR NOTY!!
  require('rrViewComponents/Form/Input/DropdownInputComponent/sw-dropdown-input.js')($el);
  modelRename($el);

  require('./sw-jquery/view-builders/sw-recaptcha')($el);
  require('./sw-jquery/view-builders/sw-accordion')($el);
  require('./sw-jquery/view-builders/sw-cart')($el);
  require('./sw-jquery/view-builders/sw-char-count')($el);
  require('./sw-jquery/view-builders/sw-comment')($el);
  require('./sw-jquery/view-builders/sw-custom-model')($el);
  require('./sw-jquery/view-builders/sw-custom-list-form')($el);
  require('./sw-jquery/view-builders/sw-form')($el);
  require('./sw-jquery/view-builders/sw-inline-editable-cms')($el);
  require('./sw-jquery/view-builders/sw-input-image-preview')($el);
  require('./sw-jquery/view-builders/sw-group-filter')($el);
  require('./sw-jquery/view-builders/sw-material-selector')($el);
  require('./sw-jquery/view-builders/sw-preview-container')($el);
  require('./sw-jquery/view-builders/sw-model-scale-modal')($el);
  require('./sw-jquery/view-builders/sw-product-description-box')($el);
  require('./sw-jquery/view-builders/sw-product-discoverability')($el);
  require('./sw-jquery/view-builders/sw-dropdown')($el);
  require('./sw-jquery/view-builders/sw-shapejs-param-updater.js')($el);
  require('./sw-jquery/view-builders/sw-pagination')($el);
  require('./sw-jquery/view-builders/sw-product-cocreator-select')($el);
  require('./sw-jquery/view-builders/sw-product-images-table')($el);
  require('./sw-jquery/view-builders/sw-item-purchase-form')($el);
  require('./sw-jquery/view-builders/sw-product-slideshow')($el);
  require('./sw-jquery/view-builders/sw-rich-text-area')($el);
  require('./sw-jquery/view-builders/sw-shopper-summary')($el);
  require('./sw-jquery/view-builders/sw-tags-input')($el);
  require('./sw-jquery/view-builders/sw-youtube-player')($el);
  require('./sw-jquery/view-builders/sw-product-pricing')($el);
  require('./sw-jquery/view-builders/sw-shapejs-sample-images')($el);
  require('./sw-jquery/view-builders/sw-shapejs-viewer')($el);
  require('./sw-jquery/view-builders/sw-shapejs-param-form')($el);
  require('./sw-jquery/view-builders/sw-shapejs-ide-form')($el);
  require('./sw-jquery/view-builders/sw-shapejs-printability-checks')($el);
  require('./sw-jquery/view-builders/sw-slider')($el);
  require('./sw-jquery/view-builders/sw-swiper')($el);
  require('./sw-jquery/view-builders/sw-target-blank-click')($el);
  require('./sw-jquery/view-builders/sw-text-spinner')($el);
  require('./sw-jquery/view-builders/sw-toggle')($el);
  require('./sw-jquery/view-builders/sw-jquery-trigger')($el);
  require('./sw-jquery/view-builders/sw-user-orientation-params')($el);
  require('./sw-jquery/view-builders/sw-user-orientation-price-change')($el);
  require('./sw-jquery/view-builders/sw-truncate')($el);
  require('./sw-jquery/view-builders/sw-list-chooser-view')($el);
  require('./sw-jquery/view-builders/sw-variant-dropdown')($el);
  require('./sw-jquery/view-builders/sw-shop-section-edit')($el);
  require('./sw-jquery/view-builders/sw-sortable')($el);
  require('./sw-jquery/view-builders/sw-typeahead')($el);
  require('./sw-jquery/view-builders/sw-tooltip')($el);
  require('./sw-jquery/view-builders/sw-context-menu')($el);
  require('./sw-jquery/view-builders/sw-date-chooser')($el);
  require('./sw-jquery/view-builders/sw-sticky-element')($el);
  require('./sw-jquery/view-builders/sw-mobile-sub-nav')($el);
  require('./sw-jquery/view-builders/sw-image-cycle')($el);
  require('./sw-jquery/view-builders/sw-transition-bar')($el);
  require('./sw-jquery/view-builders/sw-drop-zone-form')($el);
  require('./sw-jquery/view-builders/sw-polling-instance-container')($el);
  require('./sw-jquery/view-builders/sw-polling-instance-view')($el);
  require('./sw-jquery/view-builders/sw-csrf-updater')($el);
  require('./sw-jquery/view-builders/sw-product-content-license')($el);
  require('./sw-jquery/view-builders/sw-content-license-modal')($el);
  require('js/sw-jquery/view-builders/sw-input-autocomplete/sw-input-autocomplete')($el);
  require('./sw-jquery/view-builders/sw-top-nav-search')($el);
  require('./sw-jquery/view-builders/sw-model-edit-material-selector-view')($el);
  require('./sw-jquery/view-builders/sw-model-edit-navigation-view')($el);
  require('./sw-jquery/view-builders/sw-model-edit-material-navigation-view')($el);
  require('./sw-jquery/view-builders/sw-three-dimensional-viewer-view')($el);
  require('./sw-jquery/view-builders/sw-forum-prepopulate')($el);
  require('./sw-jquery/view-builders/sw-pdf-viewer')($el);
  require('rrViewComponents/Model/MaterialConfigurator/ModelMaterialDragAndDropUploadComponent/sw-model-material-drag-and-drop-upload')($el);

  // Loads legacy JS removed from templates as AMD modules
  require('./sw-jquery/view-builders/sw-legacy-js-loader')($el);

  // Deferred Component Support
  require('./sw-jquery/view-builders/sw-deferred-component')($el);

  // This is for now just used by SW admin. Shouldn't be included for everyone
  require('./sw-jquery/view-builders/sw-plus-minus-control')($el);
});

/**
 * Load jquery autohandlers
 *
 * These respond to all events at all times
 */
require('./sw-jquery/autohandlers/sw-add-list');
require('./sw-jquery/autohandlers/sw-rush-cutoff-time.js');
require('./sw-jquery/autohandlers/sw-add-to-cart');
require('./sw-jquery/autohandlers/sw-dms-search-overlay');
require('js/sw-jquery/autohandlers/sw-char-case');
require('./sw-jquery/autohandlers/sw-cocreator');
require('./sw-jquery/autohandlers/sw-set-cookie');
require('./sw-jquery/autohandlers/sw-copy-edit-button');
require('./sw-jquery/autohandlers/sw-custom-model-product-page');
require('./sw-jquery/autohandlers/sw-input-auto-highlight');
require('./sw-jquery/autohandlers/sw-file-input');
require('./sw-jquery/autohandlers/sw-login-link');
require('./sw-jquery/autohandlers/sw-login-form');
require('./sw-jquery/autohandlers/sw-modal-trigger');
require('js/sw-jquery/autohandlers/sw-noty');
require('./sw-jquery/autohandlers/sw-pattern');
require('./sw-jquery/autohandlers/sw-pattern-force');
require('./sw-jquery/autohandlers/sw-prevent-empty');
require('./sw-jquery/autohandlers/sw-select-url');
require('./sw-jquery/autohandlers/sw-share');
require('./sw-jquery/autohandlers/sw-sign-up-form');
require('./sw-jquery/autohandlers/sw-auto-submit');
require('./sw-jquery/autohandlers/sw-trigger-event');
require('./sw-jquery/autohandlers/sw-3d-tools');
require('./sw-jquery/autohandlers/sw-update-shipping-options');
require('./sw-jquery/autohandlers/sw-model-posing-tracking');
require('./sw-jquery/autohandlers/sw-change-attribute');
require('js/sw-jquery/autohandlers/sw-sso-login');
require('./sw-jquery/autohandlers/sw-user-setting');
require('js/sw-jquery/autohandlers/sw-upload-model-modal');
require('./sw-jquery/autohandlers/sw-ajax');
require('./sw-jquery/autohandlers/sw-default-variant-option');
require('./sw-jquery/autohandlers/sw-email-modal');
require('./sw-jquery/autohandlers/sw-confirm');
require('./sw-jquery/autohandlers/sw-prevent-click');
require('./sw-jquery/autohandlers/sw-prevent-default');
require('./sw-jquery/autohandlers/sw-ip-model-match');
require('./sw-jquery/autohandlers/sw-input-threshold');
require('./sw-jquery/autohandlers/sw-make-contenteditable');
require('./sw-jquery/autohandlers/sw-model-edit');
require('./sw-jquery/autohandlers/sw-datepicker');
require('./sw-jquery/autohandlers/sw-model-update-trigger');
require('./sw-jquery/autohandlers/sw-update-netfabb-download-server');
require('./sw-jquery/autohandlers/sw-post-to-url');
require('./sw-jquery/autohandlers/sw-add-to-cart-form');
// Remove once we depracate this feature
require('./sw-jquery/autohandlers/sw-trigger-merge-modal');
require('rrViewComponents/Inshape/TrayCrashRecovery/TrayCrashRecoveryTableComponent/sw-tray-crash-reprint');
// Autohandlers that have nothing to do with jQuery
require('./sw-jquery/autohandlers/sw-trigger-noty');
require('./sw-jquery/autohandlers/sw-mmc-upload-or-signup');
require('./sw-jquery/autohandlers/sw-expire-duplicate-sessionid-cookie');


// Set up endpoint polling
_.each(SW.data['polling-endpoints'], function(pollingData) {
  SW.polling(pollingData.endpoint, function(data) {
    SW.trigger(pollingData.event, data);
  });
}, this);


// Anti-fraud
require('./lib/sw-anti-fraud');

SW.notifications = require('./lib/notifications/sw-notifications');

/**
 * This is used to help legacy code. It is better to import
 * use the sw-login-link autohandler or
 * require('js/lib/notifications/sw-signup-dialog') directly.
 *
 * @deprecated
 */
SW.notifications.login = require('js/lib/notifications/sw-signup-dialog');

// Help keep legacy code active
$(function() {
  var $el = $('body');

  SW.trigger('sw-fragment-loaded', $el);
  $el.trigger('shapeways-ready');
});
